<div class="mb-3">
  <h1 class="fs-5 fw-bold mb-0">Cost Log</h1>
</div>

<div class="card border-0 shadow mb-3 fade-in-zoom">
  <div class="card-header fw-bold bg-tertiary p-3 border-0">
    <h2 class="fs-6 fw-bold mb-0"><i class="bi bi-filter me-2 text-primary"></i>Filters</h2></div>
    <div class="card-body">
      <div class="row mb-3">
        <div class="col-6">
          <app-date-range-selector [date]="'this-month'" [zone]="'Europe/Paris'"></app-date-range-selector>
        </div>

        <div class="col-3">
          <label class="form-label fw-bold small">Partner</label>
          <div class="input-group">
            <span class="input-group-text"><i class="bi bi-diagram-3"></i></span>
            <select class="form-select" [(ngModel)]="filters.partner">
              <option [ngValue]="null">All partners</option>
              @for (partner of partners; track partner) {
                <option [ngValue]="partner">{{ partner }}</option>
              }
            </select>
          </div>
        </div>

        <div class="col-3">
          <label class="form-label">Advertising Platform</label>
          <div class="input-group">
            <span class="input-group-text"><i class="bi bi-bar-chart-line"></i></span>
            <select class="form-select" [(ngModel)]="filters.advertisingPlatform">
              <option [ngValue]="null">All platforms</option>
              @for (advertisingPlatform of advertisingPlatforms; track advertisingPlatform) {
                <option
                  [value]="advertisingPlatform.id">{{ advertisingPlatform.name }}
                </option>
              }
            </select>
          </div>
        </div>
      </div>

      <div class="row mb-3">
        <div class="offset-9 col-3">
          <label for="groupBy" class="form-label fw-bold small">Group By</label>
          <div class="input-group">
            <span class="input-group-text"><i class="bi bi-diagram-2"></i></span>
            <select id="groupBy" class="form-select" [(ngModel)]="filters.groupBy">
              <option value="date-day">Date - by day</option>
              <option value="partner">Partners</option>
            </select>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 mt-4 text-end d-flex align-items-end justify-content-end">
          <button type="button" class="btn btn-outline-primary fw-bold me-2" [disabled]="loading || !rows.length"
            (click)="downloadCsv()"><i
          class="bi bi-file-earmark-spreadsheet"></i> Export to CSV
        </button>
        <button type="submit" class="btn btn-primary fw-bold" (click)="filter()">Apply filters</button>
      </div>
    </div>
  </div>
</div>

@if (!loading) {
  <div class="card border-0 shadow mb-3">
    <div class="card-header fw-bold bg-tertiary p-3 border-0">
      <h2 class="fs-6 fw-bold mb-0"><i class="bi bi-file-earmark-spreadsheet me-2"></i>Detailed costs</h2>
    </div>
    <div class="card-body">
      <div class="table-responsive">
        <table class="table table-hover table-striped align-middle">
          <thead class="thead-light">
            <tr [tableSorter]="tableSorter">
              <th tableSorterHeader="key">{{ getGroupByColumnName() }}</th>
              <th tableSorterHeader="impressions">Impressions</th>
              <th tableSorterHeader="clicks">Clicks</th>
              <th tableSorterHeader="costs">Cost</th>
              <th tableSorterHeader="costsUsd">Cost USD</th>
              <th>Not allocated</th>
            </tr>
          </thead>
          <tbody>
            @for (row of rows | tableSort: tableSorter; track row) {
              <tr (click)="showCostDetail(row)" class="detail-row">
                <td class="fw-bold">{{ getLabel(row) }}</td>
                <td>{{ row.impressions }}</td>
                <td>{{ row.clicks }}</td>
                <td>{{ row.costs | money }}</td>
                <td>{{ row.costsUsd | money:2:'USD' }}</td>
                <td>{{ getNotAllocatedCosts(row) | money }} / {{ getNotAllocatedCostsUsd(row) | money:2:'USD' }}</td>
              </tr>
            }
            <tr>
              <td class="fw-bold">Total</td>
              <td class="fw-bold">{{ totals.impressions }}</td>
              <td class="fw-bold">{{ totals.clicks }}</td>
              <td class="fw-bold">{{ totals.costs | money }}</td>
              <td class="fw-bold">{{ totals.costsUsd | money:2:'USD' }}</td>
              <td class="fw-bold">{{ getNotAllocatedCosts(totals) | money }}
                / {{ getNotAllocatedCostsUsd(totals) | money:2:'USD' }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
}
